import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/mail`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}` } });

export const mailApi = {
  status: () => axios.get(`${API}/status`, hdr()).then((r) => r.data),
  scan: () => axios.post(`${API}/scan`, null, hdr()).then((r) => r.data),
  senders: (kind, q) => axios.get(`${API}/senders`, { params: { kind, q }, ...hdr() }).then((r) => r.data),
  needsReply: () => axios.get(`${API}/needs-reply`, hdr()).then((r) => r.data),
  rules: () => axios.get(`${API}/rules`, hdr()).then((r) => r.data),
  applyRulesNow: () => axios.post(`${API}/rules/apply-now`, {}, hdr()).then((r) => r.data),
  deleteRule: (em) => axios.delete(`${API}/rules/${encodeURIComponent(em)}`, hdr()).then((r) => r.data),
  sendersAction: (emails, action, label) => axios.post(`${API}/senders/action`, { emails, action, label }, hdr()).then((r) => r.data),
  labels: () => axios.get(`${API}/labels`, hdr()).then((r) => r.data),
  classify: (onlyNew = false) => axios.post(`${API}/labels/classify`, null, { params: { only_new: onlyNew }, ...hdr() }).then((r) => r.data),
  labelSuggestions: () => axios.get(`${API}/labels/suggestions`, hdr()).then((r) => r.data),
  setLabelSuggestion: (email, label) => axios.put(`${API}/labels/suggestions`, { email, label }, hdr()).then((r) => r.data),
  messagesAction: (ids, action) => axios.post(`${API}/messages/action`, { ids, action }, hdr()).then((r) => r.data),
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "2-digit" }) : "—");
let gmailAccount = "";
export const setGmailAccount = (email) => { gmailAccount = email || ""; };
const gmailBase = () => `https://mail.google.com/mail/?authuser=${encodeURIComponent(gmailAccount)}`;
export const gmailLink = (messageId) => (messageId ? `${gmailBase()}#search/rfc822msgid:${encodeURIComponent(messageId)}` : `${gmailBase()}#inbox`);
export const gmailSenderLink = (email) => `${gmailBase()}#search/from:${encodeURIComponent(email)}`;
